import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { CameraTitleWrapper } from '../../Camera/CameraTitleComponent';

import StyledLink from '../../StyledLink';
import { StyledBMXAuthenticationContainer } from './styledComponents';

const BMXAuthenticationComponent = (props) => {
  const { buildingId, buildingName, cameraName, message } = props;
  return (
    <Box position="relative" width="100%">
      <StyledBMXAuthenticationContainer>
        <Box display="flex">
          <StyledLink to={`/buildings/${buildingId}`}>
            <CameraTitleWrapper>{buildingName}</CameraTitleWrapper>
          </StyledLink>
          <span>&nbsp;-&nbsp;</span>
          <span>{cameraName}</span>
        </Box>
        <div>{message}</div>
      </StyledBMXAuthenticationContainer>
    </Box>
  );
};

BMXAuthenticationComponent.defaultProps = {
  message: null,
};

BMXAuthenticationComponent.propTypes = {
  buildingId: PropTypes.number.isRequired,
  buildingName: PropTypes.string.isRequired,
  cameraName: PropTypes.string.isRequired,
  message: PropTypes.string,
};

export default BMXAuthenticationComponent;
